import type { RouteConfig } from 'vue-router'

import * as namesConfiguracion from './nombres/configuracion'
import * as namesInformes from './nombres/informes'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { TipoArticulo } from '@/@core/utils/enums/compras'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosCompras, { RESOURCE_COMPRAS } from '@/auth/permissions/modules/compras'

const { mantenimiento, configuracion, transacciones, informes } = permisosCompras
export default [
    /**
     * RUTAS DE MANTENIMIENTO
     */
    {
        path: '/compras/mantenimiento/categoria-servicio',
        name: namesMantenimiento.ROUTE_CATEGORIAS_SERVICIO,
        component: () => import('@pages/compras/mantenimiento/CrearCategoriaServicio.vue'),
        meta: {
            title: 'i18n:compras.subopciones.categoria_servicio',
            resource: RESOURCE_COMPRAS,
            action: mantenimiento.categoriasServicio,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.mantenimiento',
                'compras.subopciones.categoria_servicio'
            ),
        },
    },
    {
        path: '/compras/mantenimiento/plantilla-requisicion/:idPlantilla?',
        name: namesMantenimiento.ROUTE_CREACION_PLANTILLA_SOLICITUD,
        component: () => import('@pages/compras/mantenimiento/GeneracionPlantilla.vue'),
        meta: {
            title: 'i18n:compras.subopciones.plantilla_solicitud',
            resource: RESOURCE_COMPRAS,
            action: mantenimiento.creacionPlantillaSolicitud,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.mantenimiento',
                'compras.subopciones.plantilla_solicitud'
            ),
        },
    },
    {
        path: '/compras/mantenimiento/jefe-area',
        name: namesMantenimiento.ROUTE_JEFE_AREA,
        component: () => import('@pages/compras/mantenimiento/ResponsablesJefatura.vue'),
        meta: {
            title: 'i18n:compras.subopciones.jefes_area',
            resource: RESOURCE_COMPRAS,
            action: mantenimiento.jefeArea,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.mantenimiento',
                'compras.subopciones.jefes_area'
            ),
        },
    },
    {
        path: '/compras/mantenimiento/linea-servicio',
        name: namesMantenimiento.ROUTE_LINEAS_SERVICIO,
        component: () => import('@pages/compras/mantenimiento/CrearLineaServicio.vue'),
        meta: {
            title: 'i18n:compras.subopciones.linea_servicio',
            resource: RESOURCE_COMPRAS,
            action: mantenimiento.lineasServicio,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.mantenimiento',
                'compras.subopciones.linea_servicio'
            ),
        },
    },
    {
        path: '/compras/mantenimiento/plantillas-requisicion',
        name: namesMantenimiento.ROUTE_PLANTILLAS_SOLICITUD,
        component: () => import('@pages/compras/mantenimiento/PlantillasSolicitudes.vue'),
        meta: {
            title: 'i18n:compras.subopciones.plantilla_solicitud',
            resource: RESOURCE_COMPRAS,
            action: mantenimiento.plantillasSolicitud,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.mantenimiento',
                'compras.subopciones.plantilla_solicitud'
            ),
        },
    },
    {
        path: '/compras/mantenimiento/servicio',
        name: namesMantenimiento.ROUTE_SERVICIOS,
        component: () => import('@pages/compras/mantenimiento/CrearServicio.vue'),
        meta: {
            title: 'i18n:compras.subopciones.servicios',
            resource: RESOURCE_COMPRAS,
            action: mantenimiento.servicios,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.mantenimiento',
                'compras.subopciones.servicios'
            ),
        },
    },

    /**
     * RUTAS DE CONFIGURACION
     */
    {
        path: '/compras/configuracion/aprobacion-contable-servicios',
        name: namesConfiguracion.ROUTE_APROBACION_CONTABLE_SERVICIOS,
        component: () => import('@pages/compras/configuracion/ConfiguracionContableServicio.vue'),
        meta: {
            title: 'i18n:compras.subopciones.config_cont_servicios',
            resource: RESOURCE_COMPRAS,
            action: configuracion.aprobacionContableServicios,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.configuracion',
                'compras.subopciones.config_cont_servicios'
            ),
        },
    },
    {
        path: '/compras/configuracion/aprobacion-tributaria-servicios',
        name: namesConfiguracion.ROUTE_APROBACION_TRIBUTARIA_SERVICIOS,
        component: () => import('@pages/compras/configuracion/ConfiguracionTributariaServicio.vue'),
        meta: {
            title: 'i18n:compras.subopciones.config_trib_servicios',
            resource: RESOURCE_COMPRAS,
            action: configuracion.aprobacionTributariaServicios,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.configuracion',
                'compras.subopciones.config_trib_servicios'
            ),
        },
    },
    {
        path: '/compras/configuracion/dueno-categoria',
        name: namesConfiguracion.ROUTE_DUENO_CATEGORIA,
        component: () => import('@pages/compras/configuracion/DuenoCategoria.vue'),
        meta: {
            title: 'i18n:compras.subopciones.dueno_categoria',
            resource: RESOURCE_COMPRAS,
            action: configuracion.duenoCategoria,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.configuracion',
                'compras.subopciones.dueno_categoria'
            ),
        },
    },
    {
        path: '/compras/configuracion/niveles-aprobacion-requisicion',
        name: namesConfiguracion.ROUTE_NIVEL_APROBACION,
        component: () => import('@/views/pages/compras/configuracion/NivelAprobacion.vue'),
        meta: {
            title: 'i18n:compras.subopciones.nivel_aprobacion',
            resource: RESOURCE_COMPRAS,
            action: configuracion.nivelAprobacionSolicitud,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.configuracion',
                'compras.subopciones.nivel_aprobacion'
            ),
        },
    },
    {
        path: '/compras/configuracion/permiso-categoria',
        name: namesConfiguracion.ROUTE_PERMISOS_CATEGORIA,
        component: () => import('@pages/compras/configuracion/AsignacionUsuarioCategoria.vue'),
        meta: {
            title: 'i18n:compras.subopciones.permiso_categoria',
            resource: RESOURCE_COMPRAS,
            action: configuracion.permisoCategoria,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.configuracion',
                'compras.subopciones.permiso_categoria'
            ),
        },
    },
    {
        path: '/compras/configuracion/responsables-aprobacion-oc',
        name: namesConfiguracion.ROUTE_RESPONSABLES_APROBACION_OC,
        component: () => import('@pages/compras/configuracion/ResponsablesAprobacionOc.vue'),
        meta: {
            title: 'i18n:compras.subopciones.responsables_aprob_oc',
            resource: RESOURCE_COMPRAS,
            action: configuracion.responsablesAprobacionOC,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.configuracion',
                'compras.subopciones.responsables_aprob_oc'
            ),
        },
    },

    /**
     * RUTAS DE TRANSACCIONES
     */

    {
        path: '/compras/transacciones/gestion-requisiciones',
        name: namesTransacciones.ROUTE_GESTION_SOLICITUDES,
        component: () => import('@pages/compras/transacciones/GestionRequisiciones.vue'),
        meta: {
            title: 'i18n:compras.subopciones.gestion_requisiciones',
            resource: RESOURCE_COMPRAS,
            action: transacciones.solicitudesCompra.gestionSolicitudes,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.gestion_requisiciones'
            ),
        },
    },
    {
        path: '/compras/transacciones/requisicion/:solicitudId?',
        name: namesTransacciones.ROUTE_CREACION_SOLICITUD,
        component: () => import('@/views/pages/compras/transacciones/crear-licitacion/CrearLicitacion.vue'),
        meta: {
            title: 'i18n:compras.subopciones.generar_solicitud',
            resource: RESOURCE_COMPRAS,
            action: transacciones.solicitudesCompra.creacionSolicitud,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.generar_solicitud'
            ),
        },
    },
    {
        path: '/compras/transacciones/aprobacion-requisicion-categoria',
        name: namesTransacciones.ROUTE_APROBACION_CATEGORIA_SOLICITUDES,
        component: () => import('@pages/compras/transacciones/aprobar-licitacion-categoria/Index.vue'),
        meta: {
            title: 'i18n:compras.subopciones.preaprobacion_solicitudes',
            resource: RESOURCE_COMPRAS,
            action: transacciones.solicitudesCompra.aprobacionSolicitudCategoria,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.preaprobacion_solicitudes'
            ),
        },
    },
    {
        path: '/compras/transacciones/aprobacion-requisicion',
        name: namesTransacciones.ROUTE_APROBACION_SOLICITUDES,
        component: () => import('@pages/compras/transacciones/aprobar-licitacion/Index.vue'),
        meta: {
            title: 'i18n:compras.subopciones.aprobacion_solicitudes',
            resource: RESOURCE_COMPRAS,
            action: transacciones.solicitudesCompra.aprobacionSolicitud,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.aprobacion_solicitudes'
            ),
        },
    },
    {
        path: '/compras/transacciones/gestion-publicaciones-requisicion',
        name: namesTransacciones.ROUTE_GESTION_PUBLICACIONES_SOLICITUD,
        component: () => import('@pages/compras/transacciones/GestionPublicaciones.vue'),
        meta: {
            title: 'i18n:compras.subopciones.gestion_publicaciones',
            resource: RESOURCE_COMPRAS,
            action: transacciones.solicitudesCompra.gestionPublicacionesSolicitud,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.gestion_publicaciones'
            ),
        },
    },
    {
        path: '/compras/transacciones/gestion-cotizaciones',
        name: namesTransacciones.ROUTE_GESTION_COTIZACIONES,
        component: () => import('@pages/compras/transacciones/GestionCotizaciones.vue'),
        meta: {
            title: 'i18n:compras.subopciones.gestion_cotizaciones',
            resource: RESOURCE_COMPRAS,
            action: transacciones.cotizaciones.gestionCotizaciones,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.gestion_cotizaciones'
            ),
        },
    },
    {
        path: '/compras/transacciones/crear-cotizacion/:num_documento?',
        name: namesTransacciones.ROUTE_CREACION_COTIZACION,
        component: () => import('@pages/compras/transacciones/crear-cotizacion/Cotizacion.vue'),
        meta: {
            title: 'i18n:compras.subopciones.generar_cotizacion',
            resource: RESOURCE_COMPRAS,
            action: transacciones.cotizaciones.creacionCotizacion,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.generar_cotizacion'
            ),
        },
    },
    {
        path: '/compras/transacciones/generacion-oc/:num_solicitud',
        name: namesTransacciones.ROUTE_SELECCION_COTIZACIONES,
        component: () => import('@pages/compras/transacciones/SeleccionCotizaciones.vue'),
        meta: {
            title: 'i18n:compras.transacciones.generacion_cotizaciones.asignar',
            resource: RESOURCE_COMPRAS,
            action: transacciones.cotizaciones.seleccionCotizaciones,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.generar_oc_cotizacion',
                'compras.transacciones.generacion_cotizaciones.asignar'
            ),
        },
    },
    {
        path: '/compras/transacciones/gestion-ordenes-compra',
        name: namesTransacciones.ROUTE_GESTION_ORDENES_COMPRA,
        component: () => import('@pages/compras/transacciones/BandejaOrdenesCompra.vue'),
        meta: {
            title: 'i18n:compras.subopciones.gestion_orden_compra',
            resource: RESOURCE_COMPRAS,
            action: transacciones.ordenesCompra.gestionOrdenCompra,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.gestion_orden_compra'
            ),
        },
    },
    {
        path: '/compras/transacciones/orden-compra/:num_orden_compra?',
        name: namesTransacciones.ROUTE_CREACION_ORDEN_COMPRA,
        component: () => import('@pages/compras/transacciones/crear-orden-compra/Index.vue'),
        meta: {
            title: 'i18n:compras.subopciones.generar_orden_compra',
            resource: RESOURCE_COMPRAS,
            action: transacciones.ordenesCompra.creacionOrdenCompra,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.generar_orden_compra'
            ),
        },
    },
    {
        path: '/compras/transacciones/aprobacion-orden-compra',
        name: namesTransacciones.ROUTE_APROBACION_ORDEN_COMPRA,
        component: () => import('@pages/compras/transacciones/aprobar-orden-compra/Index.vue'),
        meta: {
            title: 'i18n:compras.subopciones.aprobacion_orden_compra',
            resource: RESOURCE_COMPRAS,
            action: transacciones.ordenesCompra.aprobacionOC,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.aprobacion_orden_compra'
            ),
        },
    },
    {
        path: '/compras/transacciones/gestion-ordenes-entrega',
        name: namesTransacciones.ROUTE_GESTION_ORDENES_ENTREGA,
        component: () => import('@pages/compras/transacciones/BandejaOrdenesEntrega.vue'),
        meta: {
            title: 'i18n:compras.subopciones.gestion_orden_entrega',
            resource: RESOURCE_COMPRAS,
            action: transacciones.ordenesEntrega.gestionOrdenEntrega,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.gestion_orden_entrega'
            ),
        },
    },
    {
        path: '/compras/transacciones/orden-entrega/:ordenEntregaId?',
        name: namesTransacciones.ROUTE_CREACION_ORDEN_ENTREGA,
        component: () => import('@/views/pages/compras/transacciones/crear-orden-entrega/CrearOrdenEntrega.vue'),
        meta: {
            title: 'i18n:compras.subopciones.generar_orden_entrega',
            resource: RESOURCE_COMPRAS,
            action: transacciones.ordenesEntrega.creacionOrdenEntrega,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.generar_orden_entrega'
            ),
        },
    },
    {
        path: '/compras/transacciones/recepcion/orden-entrega-bien',
        name: namesTransacciones.ROUTE_RECEPCION_ORDEN_ENTREGA_BIEN,
        component: () => import('@pages/compras/transacciones/recepcion-orden-entrega/RecepcionOrdenEntrega.vue'),
        meta: {
            title: 'i18n:compras.subopciones.recepcion_orden_entrega_bien',
            resource: RESOURCE_COMPRAS,
            action: transacciones.ordenesEntrega.recepcionOrdenEntregaBien,
            tipoArticulo: TipoArticulo.BIEN,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.recepcion_orden_entrega_bien'
            ),
        },
    },
    {
        path: '/compras/transacciones/recepcion/orden-entrega-servicio',
        name: namesTransacciones.ROUTE_RECEPCION_ORDEN_ENTREGA_SERVICIO,
        component: () => import('@pages/compras/transacciones/recepcion-orden-entrega/RecepcionOrdenEntrega.vue'),
        meta: {
            title: 'i18n:compras.subopciones.recepcion_orden_entrega_servicio',
            resource: RESOURCE_COMPRAS,
            action: transacciones.ordenesEntrega.recepcionOrdenEntregaServicio,
            tipoArticulo: TipoArticulo.SERVICIO,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.recepcion_orden_entrega_servicio'
            ),
        },
    },
    {
        path: '/compras/transacciones/recepcion/revision-orden-entrega',
        name: namesTransacciones.ROUTE_REVISION_RECEPCION_ORDEN_ENTREGA,
        component: () => import('@pages/compras/transacciones/RevisionRecepcionOrdenEntrega.vue'),
        meta: {
            title: 'i18n:compras.subopciones.revision_recepcion_orden_entrega',
            resource: RESOURCE_COMPRAS,
            action: transacciones.ordenesEntrega.revisionRecepcionOrdenEntrega,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.transacciones',
                'compras.subopciones.revision_recepcion_orden_entrega'
            ),
        },
    },

    /**
     * RUTAS DE INFORMES
     */
    {
        path: '/compras/informes/requisiciones-x-status',
        name: namesInformes.ROUTE_SOLICITUDES_X_STATUS,
        component: () => import('@pages/compras/informes/SolicitudesXStatus.vue'),
        meta: {
            title: 'i18n:compras.subopciones.solicitudes_x_status',
            resource: RESOURCE_COMPRAS,
            action: informes.solicitudesXStatus,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.solicitudes_x_status'
            ),
        },
    },
    {
        path: '/compras/informes/requisiciones-x-item',
        name: namesInformes.ROUTE_SOLICITUDES_X_ITEM,
        component: () => import('@pages/compras/informes/SolicitudesXItem.vue'),
        meta: {
            title: 'i18n:compras.subopciones.solicitudes_x_item',
            resource: RESOURCE_COMPRAS,
            action: informes.solicitudesXItem,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.solicitudes_x_item'
            ),
        },
    },
    {
        path: '/compras/informes/ordenes-compra-x-status',
        name: namesInformes.ROUTE_ORDENES_COMPRA_X_STATUS,
        component: () => import('@pages/compras/informes/OrdenesCompraXStatus.vue'),
        meta: {
            title: 'i18n:compras.subopciones.ordenes_compra_x_status',
            resource: RESOURCE_COMPRAS,
            action: informes.ordenesCompraXStatus,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.ordenes_compra_x_status'
            ),
        },
    },
    {
        path: '/compras/informes/items-x-orden-compra',
        name: namesInformes.ROUTE_ITEM_X_ORDENES_COMPRA,
        component: () => import('@pages/compras/informes/ItemsXOrdenCompra.vue'),
        meta: {
            title: 'i18n:compras.subopciones.items_x_orden_compra',
            resource: RESOURCE_COMPRAS,
            action: informes.itemXOrdenesCompra,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.items_x_orden_compra'
            ),
        },
    },
    {
        path: '/compras/informes/historial-precios',
        name: namesInformes.ROUTE_HISTORIAL_PRECIOS,
        component: () => import('@pages/compras/informes/HistorialPrecios.vue'),
        meta: {
            title: 'i18n:compras.subopciones.historial_precios',
            resource: RESOURCE_COMPRAS,
            action: informes.historialPrecios,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.historial_precios'
            ),
        },
    },
    {
        path: '/compras/informes/orden-compra-vs-recepcion-bodega',
        name: namesInformes.ROUTE_ORDENES_COMPRA_VS_RECEPCION_BODEGA,
        component: () => import('@pages/compras/informes/OrdenCompraVsRecepcionBodega.vue'),
        meta: {
            title: 'i18n:compras.subopciones.orden_compra_vs_recepcion_bodega',
            resource: RESOURCE_COMPRAS,
            action: informes.ordenesCompraVsRecepcionBodega,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.orden_compra_vs_recepcion_bodega'
            ),
        },
    },
    {
        path: '/compras/informes/seguimiento-requisiciones',
        name: namesInformes.ROUTE_SEGUIMIENTO_SOLICITUDES,
        component: () => import('@pages/compras/informes/SeguimientoSolicitudes.vue'),
        meta: {
            title: 'i18n:compras.subopciones.seguimiento_solicitudes',
            resource: RESOURCE_COMPRAS,
            action: informes.seguimientoSolicitudes,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.seguimiento_solicitudes'
            ),
        },
    },
    {
        path: '/compras/informes/costos-cotizaciones',
        name: namesInformes.ROUTE_COSTOS_COTIZACIONES,
        component: () => import('@pages/compras/informes/CostosCotizaciones.vue'),
        meta: {
            title: 'i18n:compras.subopciones.costos_cotizaciones',
            resource: RESOURCE_COMPRAS,
            action: informes.costosCotizaciones,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.costos_cotizaciones'
            ),
        },
    },
    {
        path: '/compras/informes/cotizaciones',
        name: namesInformes.ROUTE_COTIZACIONES,
        component: () => import('@pages/compras/informes/ReporteCotizaciones.vue'),
        meta: {
            title: 'i18n:compras.subopciones.cotizaciones',
            resource: RESOURCE_COMPRAS,
            action: informes.cotizaciones,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.cotizaciones'
            ),
        },
    },
    {
        path: '/compras/informes/ordenes-entrega-x-status',
        name: namesInformes.ROUTE_ORDENES_ENTREGA_X_STATUS,
        component: () => import('@pages/compras/informes/OrdenesEntregaXStatus.vue'),
        meta: {
            title: 'i18n:compras.subopciones.ordenes_entrega_x_status',
            resource: RESOURCE_COMPRAS,
            action: informes.ordenesEntregaXStatus,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.ordenes_entrega_x_status'
            ),
        },
    },
    {
        path: '/compras/informes/recepciones-orden-entrega',
        name: namesInformes.ROUTE_RECEPCIONES_ORDEN_ENTREGA,
        component: () => import('@pages/compras/informes/RecepcionesOrdenEntrega.vue'),
        meta: {
            title: 'i18n:compras.subopciones.recepciones_orden_entrega',
            resource: RESOURCE_COMPRAS,
            action: informes.recepcionesOrdenEntrega,
            breadcrumb: buildBreadcrumb(
                'a:compras.menu_title',
                'a:global.menu.informes',
                'compras.subopciones.recepciones_orden_entrega'
            ),
        },
    },
] as RouteConfig[]
